<template>
  <div
    class="t-btn d-flex justify-center align-center"
    :class="{ disabled, fill }"
    :style="{ width, height, fontSize, fontWeight }"
    v-ripple="!disabled"
    @click="click"
    @mouseenter="enter"
    @mouseleave="leave"
  >
    <slot></slot>
    <transition name="fade">
      <t-tooltip
        v-if="tooltipShow"
        :position="tooltipPosition"
        :text="tooltip"
      />
    </transition>
  </div>
</template>

<script>
import LabelTooltip from "@/components/labelTooltip.vue";

export default {
  components: {
    "t-tooltip": LabelTooltip,
  },
  props: {
    /** 버튼 text */
    label: {
      type: String,
      default: () => "",
    },
    /** 버튼 width */
    width: {
      type: String,
      default: () => "",
    },
    /** 버튼 height */
    height: {
      type: String,
      default: () => "34px",
    },
    /** 버튼 비활성화 */
    disabled: {
      type: Boolean,
      default: () => false,
    },
    /** 폰트 size */
    fontSize: {
      type: String,
      default: () => "16px",
    },
    /** 폰트 weight */
    fontWeight: {
      type: String,
      default: () => "800",
    },
    /** 색상 채우기 */
    fill: {
      type: Boolean,
      default: () => false,
    },
    /** 툴팁 text */
    tooltip: {
      type: String,
      default: () => "",
    },
    position: {
      type: String,
      default: () => "left",
    },
  },
  data: () => {
    return {
      delayTimeout: null,
      tooltipShow: false,
      tooltipPosition: { top: "0", left: "0" },
    };
  },
  watch: {
    position() {
      this.tooltipPosition = { top: "0", right: "100px" };
    },
  },

  methods: {
    /** 클릭 이벤트 */
    click(e) {
      if (this.disabled) return;
      this.$emit("click", e);
    },
    /** 툴팁 enter */
    enter(e) {
      if (!this.tooltip.trim()) return;

      this.delayTimeout = setTimeout(() => {
        this.tooltipShow = true;
        const rect = e.target.getBoundingClientRect();
        if (this.position === "left") {
          this.tooltipPosition = {
            top: `${rect.top + 37}px`,
            left: `${rect.left}px`,
          };
        } else {
          this.tooltipPosition = {
            top: `${rect.top + 40}px`,
            right: `100px`,
            left: `none`,
          };
        }
      }, 300);
    },
    /** 툴팁 leave */
    leave() {
      //clearTimeout(this.delayTimeout);
      this.tooltipShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
$black: var(--m-black01);
$white: var(--m-white);
$blue-primary: var(--p-blue00);
$blue: var(--p-blue02);
$purple: var(--p-purple00);
$purple-secondary: var(--s-purple00);
$red: var(--s-red00);
$gray: var(--m-gray02);
$darkGray: var(--c-333);

.t-btn {
  padding: 6px 14px;
  border-radius: 10px;
  cursor: pointer;
  user-select: none;

  &.black {
    background-color: transparent !important;
    border: 1px solid $black !important;
    color: $black !important;

    &.fill {
      background-color: $black !important;
      border: none !important;
      color: $white !important;
    }
  }

  &.blue-primary {
    background-color: transparent !important;
    border: 1px solid $blue-primary !important;
    color: $blue-primary !important;

    &.fill {
      background-color: $blue-primary !important;
      border: none !important;
      color: $white !important;
    }
  }

  &.blue {
    background-color: transparent !important;
    border: 1px solid $blue !important;
    color: $blue !important;

    &.fill {
      background-color: $blue !important;
      border: none !important;
      color: $white !important;
    }
  }

  &.purple {
    background-color: transparent !important;
    border: 1px solid $purple !important;
    color: $purple !important;

    &.fill {
      background-color: $purple !important;
      border: none !important;
      color: $white !important;
    }
  }

  &.purple-secondary {
    background-color: transparent !important;
    border: 1px solid $purple-secondary !important;
    color: $purple-secondary !important;

    &.fill {
      background-color: $purple-secondary !important;
      border: none !important;
      color: $white !important;
    }
  }

  &.red {
    background-color: transparent !important;
    border: 1px solid $red !important;
    color: $red !important;

    &.fill {
      background-color: $red !important;
      border: none !important;
      color: $white !important;
    }
  }

  &.gray {
    background-color: transparent !important;
    border: 1px solid $darkGray !important;
    color: $darkGray !important;

    &.fill {
      background-color: $gray !important;
      border: none !important;
      color: $white !important;
    }
  }

  &.red {
    background-color: transparent !important;
    border: 1px solid $red !important;
    color: $red !important;

    &.fill {
      background-color: $red !important;
      border: none !important;
      color: $white !important;
    }
  }

  &.disabled {
    background-color: transparent !important;
    border: 1px solid $gray !important;
    color: $gray !important;
    user-select: none;
    cursor: unset;

    &.fill {
      background-color: $gray !important;
      border: none !important;
      color: $white !important;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
